import type { Middleware } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import { initializeCreditApp } from '@makemydeal/activities-credit-app';
import { Actions } from '@makemydeal/dr-sales-checkin-store';
import type { getCreditAppMiddlewareManager } from './config';
import { configureCreditApp } from './config';

let cachedCreditAppMiddlewareManager: ReturnType<typeof getCreditAppMiddlewareManager> | undefined;

// Exported for testing
export const creditAppMiddlewareClearCache = () => (cachedCreditAppMiddlewareManager = undefined);

/**
 * Credit App middleware for Sales Check-In
 * Handles bootstrap initialization and Sales Check-In lifecycle actions
 */
export const creditAppMiddleware: Middleware = (store) => (next) => (action: AnyFSA) => {
    switch (action.type) {
        case bootstrapActionTypes.BOOTSTRAP_SUCCESS: {
            if (!cachedCreditAppMiddlewareManager) {
                const { middlewareManager } = configureCreditApp();
                cachedCreditAppMiddlewareManager = middlewareManager;
            }
            break;
        }

        case Actions.GET_DETAILS_SUCCESS: {
            // Initialize credit app when fetching existing deal
            // Note: This action will be utilized once credit app data is persisted to the deal
            const creditAppData = action.payload?.data?.creditApp;
            const dealRefId = action.payload?.data?.dealRefId;

            if (creditAppData) {
                store.dispatch(initializeCreditApp(creditAppData, dealRefId));
            }
            break;
        }
    }

    if (cachedCreditAppMiddlewareManager) {
        return cachedCreditAppMiddlewareManager.middleware(store)(next)(action);
    }

    return next(action);
};
